"use client";

import { useLocale } from "@/hooks/useLocale";
import { motion } from "framer-motion";

export default function Service() {
  const { currentLocale } = useLocale();

  return (
    <motion.section
      className="mx-auto max-w-prose mt-32"
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6 }}
    >
      <section className="mx-auto max-w-prose px-4 py-12 sm:px-6 sm:py-16">
        {currentLocale === "zh-CN" && (
          <div className="mx-auto max-w-3xl">
            <h1 className="text-3xl leading-8 font-extrabold tracking-tight sm:text-4xl">
              服务条款
            </h1>
            <article className="prose dark:prose-invert text-base">
              <div>
                <p>生效日期: 2025.07.18</p>
                <p>更新日期: 2025.07.18</p>
                <h2>摘要</h2>
                <p>
                  欢迎使用 <strong>VPN指南</strong>
                  （以下简称"本服务"）。以下条款适用于您使用本服务的所有行为。请在使用本服务前仔细阅读并确保理解和同意以下条款的全部内容。如果您不同意本条款的任何内容，请停止使用本服务。
                </p>

                <h2 id="acceptance" className="scroll-mt-24">
                  接受条款
                </h2>
                <p>
                  当您访问、浏览或使用本服务时，即表示您已阅读、理解并同意受本条款的约束。
                </p>
                <p>
                  我们有权在必要时修改本条款，并会通过网站公告或其他合理方式通知您。若您在本条款更新后继续使用本服务，则视为您已接受修订后的条款。
                </p>

                <h2 id="service-description" className="scroll-mt-24">
                  服务说明
                </h2>
                <h3>主要功能</h3>
                <p>
                  本服务是一个VPN信息聚合平台，提供VPN服务提供商的信息、评论、比较和工具链接。我们收集和展示各种VPN服务的详细信息，帮助用户做出明智的选择。
                </p>

                <h3>服务限制</h3>
                <p>
                  本服务仅提供信息参考和导航功能，不直接提供VPN服务。您应确保使用VPN服务的方式符合适用法律法规及服务提供商的使用条款。
                </p>

                <h2 id="user-conduct" className="scroll-mt-24">
                  用户行为规范
                </h2>
                <h3>合法使用</h3>
                <p>
                  您应确保使用本服务的行为不违反法律法规、社会公德以及本服务的相关规则。请确保您使用VPN服务的方式符合当地法律要求。
                </p>

                <h3>尊重知识产权</h3>
                <p>
                  您在使用本服务时，应尊重所有相关方的知识产权。本网站的内容、设计、商标等知识产权均受法律保护，未经许可不得复制、传播或用于商业目的。
                </p>

                <h3>禁止行为</h3>
                <p>
                  您不得通过本服务传播任何违反法律法规的内容，不得利用本服务从事任何破坏网络安全、侵犯他人隐私或进行其他违法活动的行为。
                </p>

                <h2 id="intellectual-property" className="scroll-mt-24">
                  知识产权
                </h2>
                <h3>VPN指南的知识产权</h3>
                <p>
                  本服务中的软件、技术、页面设计、LOGO、商标等所有相关知识产权均归
                  <strong>VPN指南</strong>
                  或其授权方所有。未经许可，任何人不得擅自复制、修改、传播或进行其他侵权行为。
                </p>

                <h3>第三方内容</h3>
                <p>
                  本服务中展示的VPN服务信息、评论等内容可能来自第三方，其知识产权归原作者所有。我们尊重并保护这些权利。
                </p>

                <h2 id="disclaimer" className="scroll-mt-24">
                  免责声明
                </h2>
                <h3>信息准确性</h3>
                <p>
                  本服务提供的VPN信息仅供参考，<strong>VPN指南</strong>
                  不对信息的准确性、完整性或及时性做任何保证。用户应自行验证信息的真实性并承担使用风险。
                </p>

                <h3>第三方服务</h3>
                <p>
                  本服务提供链接到第三方VPN服务，但我们不对这些第三方服务的质量、安全性或可用性承担责任。用户使用第三方服务时应遵守其服务条款。
                </p>

                <h3>技术故障</h3>
                <p>
                  本服务可能因系统维护、设备故障、网络原因等导致暂时中断或无法使用，
                  <strong>VPN指南</strong>
                  不承担由此造成的任何损失或责任，但将尽力减少因此给您带来的影响。
                </p>

                <h3>用户责任</h3>
                <p>
                  由于用户违反本条款或相关法律法规，导致第三方投诉、诉讼或索赔的，用户应自行承担相应责任，并使
                  <strong>VPN指南</strong>免受损害。
                </p>

                <h2 id="liability-limitation" className="scroll-mt-24">
                  责任限制
                </h2>
                <p>
                  在适用法律允许的范围内，对于因使用或无法使用本服务而造成的任何直接、间接、附带、特殊或衍生损害，
                  <strong>VPN指南</strong>
                  不承担任何责任。本服务按"现状"提供，不保证能满足您的全部需求或不出错。
                </p>

                <h2 id="service-changes" className="scroll-mt-24">
                  服务变更与终止
                </h2>
                <h3>服务变更</h3>
                <p>
                  <strong>VPN指南</strong>
                  有权根据实际情况对本服务的部分或全部功能进行修改、暂停或终止，并提前在网站或通过其他方式通知用户。
                </p>

                <h3>终止</h3>
                <p>
                  如您违反本条款或相关法律法规，<strong>VPN指南</strong>
                  有权立即终止向您提供服务，并保留追究法律责任的权利。
                </p>

                <h2 id="governing-law" className="scroll-mt-24">
                  适用法律与争议解决
                </h2>
                <h3>适用法律</h3>
                <p>
                  本条款的成立、效力、解释及争议解决，均适用本服务运营方所在地的法律。
                </p>

                <h3>争议解决</h3>
                <p>
                  若因本条款或本服务引起争议，双方应友好协商解决；协商不成的，可向运营方所在地有管辖权的人民法院提起诉讼。
                </p>
              </div>
            </article>
          </div>
        )}

        {currentLocale === "en-US" && (
          <div className="mx-auto max-w-3xl">
            <div>
              <h1 className="text-3xl leading-8 font-extrabold tracking-tight sm:text-4xl">
                Service Terms
              </h1>

              <article className="prose dark:prose-invert text-base">
                <div>
                  <p>Effective date: 2025.07.18</p>
                  <p>Updated on: 2025.07.18</p>

                  <p>
                    Welcome to <strong>VPN Guide</strong> (hereinafter referred
                    to as "the Service"). The following terms apply to all your
                    actions in using the Service. Please read these terms
                    carefully and ensure that you understand and agree to all of
                    them before using the Service. If you do not agree to any of
                    these terms, please stop using the Service.
                  </p>
                  <h2 id="acceptance-en" className="scroll-mt-24">
                    Acceptance of Terms
                  </h2>
                  <p>
                    By accessing, browsing, or using the Service, you
                    acknowledge that you have read, understood, and agree to be
                    bound by these terms.
                  </p>
                  <p>
                    We reserve the right to modify these terms as necessary, and
                    we will notify you via website announcements or other
                    reasonable means. Your continued use of the Service after
                    any updates will be deemed as acceptance of the revised
                    terms.
                  </p>
                  <h2 id="service-description-en" className="scroll-mt-24">
                    Service Description
                  </h2>
                  <h3>Main Features</h3>
                  <p>
                    The Service is a VPN information aggregation platform that
                    provides information, reviews, comparisons, and tool links
                    for VPN service providers. We collect and display detailed
                    information about various VPN services to help users make
                    informed decisions.
                  </p>
                  <h3>Service Limitations</h3>
                  <p>
                    The Service provides information reference and navigation
                    functions only and does not directly provide VPN services.
                    You must ensure that your use of VPN services complies with
                    applicable laws, regulations, and the terms of service of
                    the providers.
                  </p>
                  <h2 id="user-conduct-en" className="scroll-mt-24">
                    User Conduct Guidelines
                  </h2>
                  <h3>Lawful Use</h3>
                  <p>
                    You must ensure that your use of the Service does not
                    violate any laws, regulations, social ethics, or the
                    relevant rules of the Service. Please ensure that your use
                    of VPN services complies with local legal requirements.
                  </p>
                  <h3>Respect for Intellectual Property</h3>
                  <p>
                    When using the Service, you should respect the intellectual
                    property rights of all relevant parties. The content,
                    design, trademarks, and other intellectual property of this
                    website are protected by law and may not be copied,
                    distributed, or used for commercial purposes without
                    permission.
                  </p>
                  <h3>Prohibited Activities</h3>
                  <p>
                    You may not distribute any content through the Service that
                    violates laws or regulations, and you may not use the
                    Service to engage in any activities that compromise network
                    security, infringe on others' privacy, or conduct other
                    illegal activities.
                  </p>
                  <h2 id="intellectual-property-en" className="scroll-mt-24">
                    Intellectual Property
                  </h2>
                  <h3>VPN Guide's Intellectual Property</h3>
                  <p>
                    All related intellectual property rights for the software,
                    technology, page designs, LOGO, trademarks, etc., in the
                    Service belong to <strong>VPN Guide</strong> or its
                    licensors. No one is allowed to copy, modify, distribute, or
                    otherwise infringe upon these rights without permission.
                  </p>
                  <h3>Third-Party Content</h3>
                  <p>
                    The VPN service information, reviews, and other content
                    displayed on this Service may come from third parties, and
                    the intellectual property rights belong to the original
                    authors. We respect and protect these rights.
                  </p>
                  <h2 id="disclaimer-en" className="scroll-mt-24">
                    Disclaimer
                  </h2>
                  <h3>Information Accuracy</h3>
                  <p>
                    The VPN information provided by the Service is for reference
                    only. <strong>VPN Guide</strong> does not guarantee the
                    accuracy, completeness, or timeliness of the information.
                    Users are responsible for verifying the authenticity of the
                    information and assuming the risks of use.
                  </p>
                  <h3>Third-Party Services</h3>
                  <p>
                    The Service provides links to third-party VPN services, but
                    we are not responsible for the quality, security, or
                    availability of these third-party services. Users should
                    comply with the terms of service when using third-party
                    services.
                  </p>
                  <h3>Technical Failures</h3>
                  <p>
                    The Service may be temporarily interrupted or unavailable
                    due to system maintenance, equipment failure, network
                    issues, etc. <strong>VPN Guide</strong> is not responsible
                    for any losses or liabilities resulting from such
                    interruptions, but will make every effort to minimize the
                    impact on you.
                  </p>
                  <h3>User Responsibility</h3>
                  <p>
                    If a user violates these terms or applicable laws and
                    regulations, resulting in complaints, litigation, or claims
                    from third parties, the user shall bear the corresponding
                    responsibilities and indemnify <strong>VPN Guide</strong>{" "}
                    from any damage.
                  </p>
                  <h2 id="liability-limitation-en" className="scroll-mt-24">
                    Limitation of Liability
                  </h2>
                  <p>
                    To the extent permitted by applicable law,{" "}
                    <strong>VPN Guide</strong> shall not be liable for any
                    direct, indirect, incidental, special, or consequential
                    damages arising from or relating to your use or inability to
                    use the Service. The Service is provided on an "as is"
                    basis, and we do not guarantee that it will meet all of your
                    needs or be error-free.
                  </p>
                  <h2 id="service-changes-en" className="scroll-mt-24">
                    Changes and Termination of the Service
                  </h2>
                  <h3>Service Changes</h3>
                  <p>
                    <strong>VPN Guide</strong> reserves the right to modify,
                    suspend, or terminate part or all of the Service's functions
                    as necessary, and will notify users in advance via the
                    website or other means.
                  </p>
                  <h3>Termination</h3>
                  <p>
                    If you violate these terms or applicable laws and
                    regulations, <strong>VPN Guide</strong> reserves the right
                    to immediately terminate the Service for you and to pursue
                    any legal remedies available.
                  </p>
                  <h2 id="governing-law-en" className="scroll-mt-24">
                    Governing Law and Dispute Resolution
                  </h2>
                  <h3>Governing Law</h3>
                  <p>
                    These terms, their validity, interpretation, and any
                    disputes arising out of them shall be governed by the laws
                    of the jurisdiction in which the Service operator is
                    located.
                  </p>
                  <h3>Dispute Resolution</h3>
                  <p>
                    In the event of any disputes arising from these terms or the
                    Service, both parties shall attempt to resolve the dispute
                    amicably; if an amicable resolution cannot be reached, the
                    dispute may be submitted to the competent People's Court in
                    the jurisdiction where the Service operator is located.
                  </p>
                </div>
              </article>
            </div>
          </div>
        )}
      </section>
    </motion.section>
  );
}
